import { useState } from 'react';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-12 left-0 right-0 bg-black/95 backdrop-blur-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold text-white tracking-wider" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              KRISPKUTZINC
            </h1>
          </div>

          <div className="hidden md:block">
            <div className="flex items-center space-x-8">
              <button onClick={() => scrollToSection('home')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Services
              </button>
              <button onClick={() => scrollToSection('about')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                About
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Gallery
              </button>
              <button onClick={() => scrollToSection('pricing')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Pricing
              </button>
              <button onClick={() => scrollToSection('team')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Team
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                Contact
              </button>
              <a 
                href="https://book.squareup.com/appointments/87v5f18dxg1ebp/location/LBKWXNEF1FVM4/services"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-amber-500 text-black px-6 py-2 rounded-full hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap font-semibold"
              >
                Book Now
              </a>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-amber-500 cursor-pointer w-8 h-8 flex items-center justify-center"
            >
              <i className={`ri-${isOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black/98">
          <div className="px-4 pt-2 pb-6 space-y-4">
            <button onClick={() => scrollToSection('home')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              About
            </button>
            <button onClick={() => scrollToSection('gallery')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Gallery
            </button>
            <button onClick={() => scrollToSection('pricing')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Pricing
            </button>
            <button onClick={() => scrollToSection('team')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Team
            </button>
            <button onClick={() => scrollToSection('contact')} className="block text-white hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap w-full text-left py-2">
              Contact
            </button>
            <a 
              href="https://book.squareup.com/appointments/87v5f18dxg1ebp/location/LBKWXNEF1FVM4/services"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-500 text-black px-6 py-2 rounded-full hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap font-semibold w-full block text-center"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
